import React from 'react';

// Horizontal pill-chip filter row
export const FilterChips = ({ label, options, value, onChange, testIdPrefix }) => (
  <div className="flex items-center gap-2 overflow-x-auto no-scrollbar py-0.5">
    {label && <span className="text-[9px] tracking-[0.2em] uppercase text-white/35 font-semibold flex-shrink-0 w-20">{label}</span>}
    {options.map(o => {
      const active = value === o.value;
      return (
        <button key={o.value} type="button" onClick={() => onChange(o.value)}
          data-testid={`${testIdPrefix}-${String(o.value).toLowerCase().replace(/\s+/g, '-')}`} data-active={active}
          className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[11px] font-medium whitespace-nowrap border transition-[background-color,border-color,color] duration-200 ${
            active ? 'bg-cyan-500/15 border-cyan-400/40 text-cyan-100' : 'bg-white/[0.02] border-white/[0.07] text-white/55 hover:text-white hover:border-white/[0.18]'
          }`}>
          {o.hex && <span className="w-1.5 h-1.5 rounded-full" style={{ background: o.hex }} />}
          {o.label}
          {o.count != null && <span className={`tabular-nums text-[9px] px-1.5 rounded-full ${active ? 'bg-cyan-400/20' : 'bg-white/[0.06] text-white/40'}`}>{o.count}</span>}
        </button>
      );
    })}
  </div>
);
